
<div class="container-fluid">
  <div class="row pt-4 pl-4" style="font-size: 22px !important;
  font-weight: 400;
  color: #424242;">
    <h5><i class="fa fa-circle" style="color:#800000"></i> &nbsp;Budget Report</h5>
  </div>
<div id="mainContent" class="container">
  <div class="modal-body">
    <div class="row">
      <div class="col-sm-5">
        <div class="row">
          <label class="col-sm-4 col-form-label"
            >Financial Year<span class="text-danger">*</span></label
          >
          <div class="col-sm-6">
            <select
              class="form-control form-control-xs mt-1"
              [(ngModel)]="selectedFinancialYear"
            >
              <option value="">Select Year</option>
              <option *ngFor="let finance of financialList" [ngValue]="finance">
                {{ finance.name }}
              </option>
            </select>
          </div>
        </div>
      </div>

      <div class="col-sm-5">
        <div class="row">
          <label class="col-sm-4 col-form-label"
            >Partner<span class="text-danger">*</span></label
          >
          <div class="col-sm-6">
            <select
              class="form-control form-control-xs mt-1"
              [(ngModel)]="selectedEmployee"
            >
              <option value="">Select Partner</option>
              <option
                *ngFor="let employee of employeeList"
                [ngValue]="employee"
              >
                {{ employee.firstName }} {{ employee.middleName }}
                {{ employee.lastName }}
              </option>
            </select>
          </div>
        </div>
      </div>
    </div>

    <div class="row mt-3">
      <div class="col-sm-2">
        <button
          type="button"
          class="btn btn-sm btn-block btn-outline-theme"
          (click)="onViewReport()"
        >
          View Report
        </button>
      </div>

      <div class="col-sm-2" *ngIf="showExportToExcelButton">
        <button
          (click)="budgetOldExportToExcelClick()"
          class="btn btn-sm btn-block btn-outline-theme"
        >
          <i class="fa fa-file-excel-o mr-2"></i>Export to Excel
        </button>
      </div>

      <div class="col-sm-3" *ngIf="showExportToExcelButton">
        <button
          (click)="budgetNewExportToExcelClick()"
          class="btn btn-sm btn-block btn-outline-theme"
        >
          <i class="fa fa-file-excel-o mr-2"></i>Excel for Update Budget
        </button>
      </div>
    </div>
  </div>
</div>

<div
  class="container tablefont pt-3" id="mainContent"
  *ngIf="reportList != null"
>
<div class="row justify-content-center text-center">
  <span class="bg-theme-title"
    >P G BHAGWAT LLP, Chartered Accountants
  </span>
</div>
<div class="row justify-content-center text-center ">
  <span>Suite 102, "Orchard", Dr Pai Marg, Baner, Pune - 411045 </span>
</div>
<div class="row col-md-12 pt-3">
  <table class="table table-bordered table-sm" style="overflow-x: auto; white-space: nowrap; display: block;">
    <thead>
      <tr>
        <!-- <th rowspan="2">Branch</th> -->
        <th rowspan="2">Client</th>
        <th rowspan="2">Assignment</th>
        <!-- <th [attr.colspan]="distinctRoles.length">Budgeted Man Days</th>
        <th [attr.colspan]="distinctRoles.length">Budgeted Count</th> -->
        <th [attr.colspan]="distinctRoles.length">Total Role Days</th>
        <th [attr.colspan]="distinctRoles.length">Total Role Cost</th>
        <th rowspan="2">Total Cost</th>
        <th rowspan="2">Fees</th>
        <th rowspan="2">Contribution</th>
        <th rowspan="2">Contribution %</th>
      </tr>
      <tr>
        <!-- <th *ngFor="let role of distinctRoles">{{ role }}</th>
        <th *ngFor="let role of distinctRoles">{{ role }}</th> -->
        <th *ngFor="let role of distinctRoles">{{ role }}</th>
        <th *ngFor="let role of distinctRoles">{{ role }}</th>
      </tr>
    </thead>
    <tbody>
      <ng-container
        *ngFor="
          let client of reportList.clients;
          let clientCount = count;
          let clientIndex = index
        "
      >
        <ng-container
          *ngFor="
            let assignment of client.assignments;
            let assignmentIndex = index;
            let assignmentCount = count
          "
        >
          <tr>
            <td
              [attr.rowspan]="assignmentCount"
              *ngIf="assignmentIndex == 0"
            >
              {{ client.client }}
            </td>
            <td>{{ assignment.assignment }}</td>
            <td *ngFor="let role of assignment.roles">
              {{ role.roleTotalManDays }}
            </td>
            <td *ngFor="let role of assignment.roles">
              {{ role.roleTotalCost }}
            </td>
            <td>{{ assignment.budgetCost }}</td>
            <td>{{ assignment.fees }}</td>
            <td>{{ assignment.contribution }}</td>
            <td>
              {{ assignment.percentage | number: "1.2-2" }}
            </td>
          </tr>
          <!-- <tr
            class="table-footer"
            *ngIf="assignmentIndex == assignmentCount - 1"
          >
            <td>Total</td>
            <td *ngFor="let role of assignment.roles">
              {{ getTotalManDays(client, role.role) }}
            </td>
            <td *ngFor="let role of assignment.roles">
              {{ getTotalCount(client, role.role) }}
            </td>
            <td *ngFor="let role of assignment.roles">
              {{ getTotalTotalManDays(client, role.role) }}
            </td>
            <td *ngFor="let role of assignment.roles">
              {{ getTotalTotalCost(client, role.role) }}
            </td>
            <td>{{ getTotalBudget(client) }}</td>
            <td>{{ getTotalFees(client) }}</td>
            <td>{{ getTotalContribution(client) }}</td>
            <td>{{ getTotalPercentage(client) | number: "1.2-2" }}</td>
          </tr> -->

          <!-- <tr
            *ngIf="
              assignmentIndex == assignmentCount - 1 &&
              clientIndex == clientCount -1
            "
            style="background-color: lightskyblue"
          >
            <td></td>
            <td>Total</td>
            <td></td>
            <td *ngFor="let role of assignment.roles">
              {{ getAllTotalManDays(role.role) }}
            </td>
            <td *ngFor="let role of assignment.roles">
              {{ getAllTotalCount(role.role) }}
            </td>
            <td *ngFor="let role of assignment.roles">
              {{ getAllTotalTotalManDays(role.role) }}
            </td>
            <td *ngFor="let role of assignment.roles">
              {{ getAllTotalTotalCost(role.role) }}
            </td>
            <td>{{ getAllTotalBudget() }}</td>
            <td>{{ getAllTotalFees() }}</td>
            <td>{{ getAllTotalContribution() }}</td>
            <td>{{ getAllTotalPercentage() | number: "1.2-2" }}</td>
          </tr> -->
        </ng-container>
      </ng-container>
      <tr>
        <td>Total</td>
        <td></td>
        <td *ngFor="let role of reportList.clients[0].assignments[0].roles">
        </td>
        <td *ngFor="let role of reportList.clients[0].assignments[0].roles">
        </td>
        <td >{{reportList.totalBudgetedCost }}</td>
        <td >{{reportList.totalBudgetedFees }}</td>
        <td >{{reportList.totalBudgetedContribution}}</td>
        <td >{{reportList.totalBudgetedContributionPercentage}}</td>
      </tr>
    </tbody>
  </table>
</div>
</div>
</div>
